<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BookingLocationListItem',
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getRestrictionDetailsByLocationId:
        'locations/getRestrictionDetailsByLocationId',
    }),
    hasBookingRestriction() {
      return !!this.getRestrictionDetailsByLocationId(this.location?.locationId)
    },
  },
  methods: {
    clicked() {
      this.$emit('itemClicked', this.location.locationId)
    },
  },
}
</script>

<template>
  <v-card
    :class="[
      'custom-elevation rounded-xl d-flex flex-column- justify-space-between align-top pa-4 overflow-hidden',
    ]"
    height="100%"
    @click="clicked"
  >
    <div>
      <header class="grow d-flex justify-space-between align-top">
        <div>
          <span class="caption opacity-6">{{ location.clientName }}</span>
          <p class="subtitle-1 text--primary booking-location-list-item__name">
            {{ location.locationName }}
          </p>
        </div>
      </header>
      <div class="caption shrink opacity-6">
        {{ `${location.addressLine1} ${location.addressLine2}` }}<br />
        {{
          `${location.suburb} ${location.state} ${location.postcode} ${location.country}`
        }}
      </div>
    </div>
    <div v-if="hasBookingRestriction" class="d-flex align-center ml-4">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            class="booking-location-list-item__alert-icon"
            color="warning"
            v-on="on"
            >mdi-alert</v-icon
          >
        </template>
        <span>
          {{ $t('bookingCreate.createBookingRestrictedTooltip') }}
        </span>
      </v-tooltip>
    </div>
  </v-card>
</template>
